import { TPromisePopupProps } from '@@types/popup';
import {
  Button,
  Checkbox,
  ModalBody,
  ModalContent,
  ModalFooter,
} from '@chakra-ui/react';
import { useState } from 'react';
import { Trans, useTranslation } from 'react-i18next';

export default function NightOrderAgreeModal({
  props,
  closePopup,
}: TPromisePopupProps) {
  const [isChecked, setIsChecked] = useState(false);
  const { t } = useTranslation('panther');
  const handleSubmit = () => {
    props.resolve(isChecked);
  };
  return (
    <ModalContent borderRadius="0">
      <ModalBody borderRadius="0">
        <div className="text-center">
          <Trans
            i18nKey="panther:night_order_notice"
            components={{
              div: <div className="flex flex-col gap-[12px]" />,
              p1: <p className="font-bold text-lg" />,
              p2: <p />,
              p3: <p />,
            }}
          />
          <div className="mt-[12px]">
            <label className="flex items-center gap-[6px] justify-center">
              <Checkbox
                isChecked={isChecked}
                onChange={(e) => setIsChecked(e.target.checked)}
              />
              <span>{t('agree_terms')}</span>
            </label>
          </div>
        </div>
      </ModalBody>
      <ModalFooter p="0">
        <Button w="50%" borderRadius="0" onClick={closePopup}>
          {t('common:cancel')}
        </Button>
        <Button
          isDisabled={!isChecked}
          w="50%"
          borderRadius="0"
          className="bg-blue-500"
          onClick={handleSubmit}
        >
          {t('common:agree')}
        </Button>
      </ModalFooter>
    </ModalContent>
  );
}
